<template>


<div class="form-wrapper">
    <!-- <el-card style="box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px !important;"> box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px; -->
    <el-card style="box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px; !important;">
    <h3>Kontaktní formulář</h3>
    <el-form label-width="100px" 
    :model="kontakt_form"
    :rules="for_rules"
    ref="formRef">

        <el-form-item label="Účel zprávy" prop="purpose">
            <el-select v-model="kontakt_form.purpose"
            placeholder="Ohlášení příletu / Jiný"
            @change="handleUcel"
            >
                <el-option label="Ohlášení příletu" value="ohlaseni" />
                <el-option label="Jiný" value="jiny" />
            </el-select>
        </el-form-item>

        <el-form-item v-if="kontakt_form.purpose == 'ohlaseni'">
            <p>
                Letiště Kroměříž je neveřejné vnitrostání letiště, všechny přílety pouze se souhlasem VLP.
                Pokud se Vám nepovede VLP kontaktovat, můžete svůj přílet ohlásit pomocí tohoto online formuláře. <br>
                Před příletem se prosím seznamte s <a href="http://lis.rlp.cz/vfrmanual/actual/lkkm_text_cz.html" target=”_blank”>VFR příručkou</a>.<br>
                Své letadlo zaparkujte na západní straně letiště vedle malého plechového hangáru –⁠ <a href="https://mapy.cz/s/3pyRm" target=”_blank”>viz mapa</a>. <br>
                Tento formulář slouží pouze k ohlášení jednoho individuálního  soukromého letu na naše letiště.
            </p>
        </el-form-item>

        <el-form-item label="Váš email" prop="sender_mail">
            <el-input v-model="kontakt_form.sender_mail" placeholder="Zadejte email"/>
        </el-form-item>



        <el-form-item label="Zpráva" prop="text">
            <el-input v-model="kontakt_form.text" type="textarea"
            placeholder="Zde pište Vaši zprávu"
            :rows="5"
            />
        </el-form-item>

        <el-form-item prop="captcha">
            <el-input v-model="kontakt_form.captcha" placeholder="Kolik je 3 + 3 ?"/>
        </el-form-item>

        <el-form-item>
            <el-button @click="submitForm(formRef)" :loading="btnLoading" >Odeslat</el-button>
        </el-form-item>


    </el-form>
    </el-card>
</div>

</template>

<script>
import { reactive, ref, toRaw} from '@vue/reactivity'
import { ElNotification} from 'element-plus'
import axios from 'axios'

export default {
    setup() {
        // Form setup
        const formRef = ref()
        const btnLoading = ref(false)
        const kontakt_form = reactive({
            sender_mail: "",
            purpose: "",
            text: "",
            captcha: ""

        });

        const ohlaseni = "Imatrikulace letounu: \nJméno a příjmení velitele: \nTelefonický kontakt: \nDatum a předpokládaný čas příletu: ";
        let text_memory = "";

        function handleUcel (parameter){
            if (parameter == "ohlaseni"){
                text_memory = kontakt_form.text;
                kontakt_form.text = ohlaseni;
            }
            else {
                kontakt_form.text = text_memory
            }

        }
        // Form validation
        const validateEmail = (rule, value, callback) => {
            if(!value){
                return callback(new Error("Vyplňte svůj email"))
            }
            setTimeout(() => {
                if (!String(value).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    callback(new Error('Zadejte email ve správném tvaru'))
                } else {
                    callback()
                }
            }, 1000)
        }
        const validateCpatcha = (rule, value, callback) => {
            if(!value){
                return callback(new Error("Vyplňte toto pole"))
            }
            setTimeout(()=>{
                try {
                    let test_int = parseInt(value)
                    if(test_int == 6){
                        callback()
                    }
                    else{
                        callback(new Error("Vyplňte správnou číselnou hodnotu"))
                    }
                } catch (error) {
                    callback(new Error("Vyplňte správnou číselnou hodnotu"))
                }
            },1000)
        }
        const for_rules = reactive({
            sender_mail: [
                {required: true, validator:validateEmail}
            ],
            purpose: [
                {required: true, message: "Zvolte jednu z možností"}
            ],
            text: [
                {required: true, message: "Vyplňte zprávu"} 
            ],
            captcha: [
                {required: true, validator: validateCpatcha}
            ]
        })

        // Notification
        const successNotification = () => {
            ElNotification({
                title: 'Zpráva odeslána!',
                message: 'Pokud Vám nedorazí kopie této zprávy, kontaktujte nás prosím klasicky pomocí emailu.',
                type: 'success',
                duration: 7000
            })
        }
        const errorNotification = () => {
            ElNotification({
                title: 'Zprávu nebylo možné odeslat...',
                message: 'Zprávu se nepodařilo úspěšně odeslat. Zkuste to prosím ještě jednou, nebo nás kontaktujte klasicky pomocí emailu.',
                type: 'error',
                duration: 15000
            })
        }

        const submitForm = async (f) => {
            btnLoading.value = true;
            setTimeout(async ()=>{
                if (!f) return
                await f.validate(async (valid, fields) => {
                    if (valid) {
                        let post_form = toRaw(JSON.parse(JSON.stringify(kontakt_form)))
                        console.log(post_form)
                        let php_form = new URLSearchParams();
                            post_form.text = post_form.text.replace(/(?:\r\n|\r|\n)/g, '<br>');
                            php_form.append('sender', post_form.sender_mail);
                            php_form.append('purpose',post_form.purpose);
                            php_form.append('text', post_form.text);
                        const response = await axios({
                            method: 'post',
                            url: 'send_post.php',
                            data: php_form
                        })
                        if(response.data == "OK"){
                            successNotification()
                        }
                        else{
                            errorNotification()
                        }
                    } else {
                        console.log('error submit!', fields)
                    }
                    btnLoading.value = false;
                })
            },3000)
        }

        return {btnLoading, kontakt_form, for_rules, formRef, handleUcel, submitForm}
        
    },
}
</script>

<style scoped>

h3{
    padding-left: 2px;
    padding-bottom: 10px;
}

p {
    line-height: 1.6;
}


.form-wrapper{
  max-width: 1300px;
  border-width: 2px;
  
}

</style>